import { FC } from 'react';
import { LoaderCircle } from '@edikk-edikk/shared';
import HeartSvg from '@edikk-edikk/country-layout-black-icon/src/heart.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { useAdvertCardContext } from '#advert/components/card';

type PropsType = {
  isProcess: boolean;
};

const FavoriteToggleIcon: FC<PropsType> = ({
  isProcess,
}) => {
  const {
    advert: {
      isFavorite,
    },
  } = useAdvertCardContext();

  if (isProcess) {
    return <LoaderCircle sizeXs borderColor="#fff" />;
  }

  return <SvgIcon Component={HeartSvg} isWithoutFill={!isFavorite} />;
};

export { FavoriteToggleIcon };
